import React from 'react';
import PropTypes from 'prop-types';

import EditFormTextarea from 'styled/Editor/FormTextarea';

import SubBlock from 'styled/Editor/SubBlock';
import Container from 'styled/Editor/Container';
import FormLabel from 'styled/Editor/FormLabel';
import LeftBlockWrapper from 'styled/Editor/LeftBlockWrapper';

import Length from './Length';

export class TextBlock extends React.PureComponent {
  render() {
    return (
      <Container>
        <LeftBlockWrapper>
          <FormLabel htmlFor={this.props.label}>
            {this.props.label}
          </FormLabel>

          <EditFormTextarea
            style={{ paddingLeft: '136px' }}
            value={this.props.value}
            maxLength={this.props.maxLength}
            placeholder={this.props.placeholder}
            onChange={this.props.onChange}
            id={this.props.label}
          />

          <Length>{this.props.value.length} / {this.props.maxLength}</Length>
        </LeftBlockWrapper>

        <SubBlock />
      </Container>
    );
  }
}

TextBlock.defaultProps = {
  label: '',
  value: '',
  onChange: () => {},
  placeholder: 'Добавьте текст',
  maxLength: 80,
};

TextBlock.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
};

export default TextBlock;
